var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg283(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.249 348.808v93.589a47.558 47.558 0 0 1-25.18 41.967l-121.266 64.747a47.554 47.554 0 0 1-44.75 0l-121.266-64.747a47.557 47.557 0 0 1-25.181-41.967v-93.589",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M632.249 348.808v93.589a47.558 47.558 0 0 1-25.18 41.967l-121.266 64.747a47.554 47.554 0 0 1-44.75 0l-121.266-64.747a47.557 47.557 0 0 1-25.181-41.967v-93.589",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m395.378 132.003 286.687 147.969a23.779 23.779 0 0 1 .286 42.11l-107 57.066a47.554 47.554 0 0 1-44.179.309L244.556 231.441a23.78 23.78 0 0 1-12.874-20.969 23.78 23.78 0 0 1 12.589-21.141l106.999-57.066a47.554 47.554 0 0 1 44.108-.262z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M531.243 132.003 244.556 279.972a23.779 23.779 0 0 0-.285 42.11l106.999 57.066a47.554 47.554 0 0 0 44.179.309l286.616-148.016a23.78 23.78 0 0 0 12.874-20.969 23.78 23.78 0 0 0-12.588-21.141l-107-57.066a47.554 47.554 0 0 0-44.108-.262z",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.312 554.7V344.363 554.7z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M463.312 554.7V344.363",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.42 60.921v5.158h-5.351c-2.234 0-4.069 1.769-4.069 3.921 0 2.153 1.835 3.921 4.069 3.921h5.351v5.158c0 2.152 1.835 3.921 4.069 3.921 2.233 0 4.068-1.769 4.068-3.921v-5.136h5.374c2.233 0 4.069-1.77 4.069-3.922s-1.836-3.921-4.069-3.921h-5.351v-5.179c0-2.152-1.836-3.921-4.091-3.921-2.234 0-4.069 1.769-4.069 3.921zM187.146 338.498v6.049h-6.332c-2.642 0-4.814 2.075-4.814 4.599 0 2.525 2.172 4.599 4.814 4.599h6.332v6.049c0 2.525 2.171 4.599 4.814 4.599 2.642 0 4.814-2.074 4.814-4.599v-6.024h6.358c2.642 0 4.814-2.074 4.814-4.599 0-2.524-2.172-4.599-4.814-4.599H196.8v-6.074c0-2.524-2.172-4.599-4.84-4.599-2.643 0-4.814 2.075-4.814 4.599zm204.6 121.724v6.049h-6.332c-2.643 0-4.814 2.074-4.814 4.599 0 2.524 2.171 4.599 4.814 4.599h6.332v6.049c0 2.524 2.171 4.599 4.814 4.599 2.642 0 4.814-2.075 4.814-4.599v-6.024h6.358c2.642 0 4.814-2.075 4.814-4.599 0-2.525-2.172-4.599-4.814-4.599H401.4v-6.074c0-2.524-2.172-4.599-4.84-4.599-2.643 0-4.814 2.075-4.814 4.599zm310.784-77.696v6.049h-6.332c-2.642 0-4.814 2.075-4.814 4.599 0 2.525 2.172 4.599 4.814 4.599h6.332v6.049c0 2.524 2.172 4.599 4.814 4.599 2.643 0 4.814-2.075 4.814-4.599v-6.024h6.358c2.642 0 4.814-2.074 4.814-4.599 0-2.524-2.172-4.599-4.814-4.599h-6.332v-6.074c0-2.524-2.171-4.599-4.84-4.599-2.642 0-4.814 2.075-4.814 4.599zM459.211 92.977v6.546h-6.937c-2.895 0-5.274 2.245-5.274 4.977s2.379 4.977 5.274 4.977h6.937v6.546c0 2.732 2.379 4.977 5.274 4.977 2.896 0 5.275-2.245 5.275-4.977v-6.519h6.965c2.896 0 5.275-2.245 5.275-4.977s-2.379-4.977-5.275-4.977h-6.937v-6.573c0-2.732-2.379-4.977-5.303-4.977-2.895 0-5.274 2.245-5.274 4.977zm79.885-40.587v9.72h-9.712c-4.053 0-7.384 3.333-7.384 7.39 0 4.057 3.331 7.39 7.384 7.39h9.712v9.72c0 4.056 3.33 7.39 7.384 7.39 4.053 0 7.384-3.334 7.384-7.39v-9.68h9.752c4.053 0 7.384-3.333 7.384-7.39 0-4.056-3.331-7.39-7.384-7.39h-9.712v-9.76c0-4.056-3.331-7.39-7.424-7.39-4.054 0-7.384 3.334-7.384 7.39z",
    fill: "#E1E4E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.059 482.936h21.781m-46.467-11.616h46.467m-20.33 23.959h20.33m427.247-12.343h-21.781m46.467-11.616h-46.467m20.329 23.959h-20.329",
    stroke: "#E1E4E5",
    strokeWidth: 4.046,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.981,
    cy: 226.959,
    rx: 87.537,
    ry: 86.993,
    fill: "#666AF6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m494.972 210.647-38.73 39.147-23.253-23.484",
    stroke: "#fff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg283);
export default __webpack_public_path__ + "static/media/283.be08b35baee37948e1bce3381f831b24.svg";
export { ForwardRef as ReactComponent };